import React, { useCallback, useEffect, useState } from 'react';
import { datetimeFromUTC, getUTCDateFromString, isDateStringValid } from 'utils/dayjs';
import bem from 'utils/bem';
import Icon from 'components/Icon';
import FormError from 'forms/fields/FormError';
import { getDateFromInput } from './utils';

import './index.sass'

const { cnBlock, el } = bem('form-field', 'common-date-input');

const CommonDateInput = ({ className, value: datepickerValue = '', error, onClick, setValue: setDatepickerValue, ...rest }) => {

    const [ value, setValue ] = useState('');

    useEffect(() => {
        if (datepickerValue === '') {
            setValue('')
        } else {
            const { date } = datetimeFromUTC(datepickerValue)
            setValue(date);
        }
    }, [datepickerValue])

    const onChange = useCallback((e) => {
        setValue(getDateFromInput(e.currentTarget.value));
    }, []);

    const onBlur = useCallback((e) => {
        const isValid = isDateStringValid(e.currentTarget.value);
        if (isValid) {
            const utcDate = getUTCDateFromString(e.currentTarget.value);
            const { date } = datetimeFromUTC(utcDate)
            setDatepickerValue(utcDate);
            setValue(date);
        } else {
            setDatepickerValue('');
            setValue('');
        }
    }, []);

    return (
        <div className={ cnBlock(className, {'active': value,  'invalid': error }) }  >
            <input {...rest} onChange={onChange} onBlur={onBlur} value={value} inputMode="numeric" />
            <Icon name={ 'calendar-blank' } onClick={onClick}/>
            { error && <FormError/> }
        </div>
    )
}

export default CommonDateInput;
